const hasOwn = (value, key) =>
  value !== null &&
  typeof value === "object" &&
  Object.prototype.hasOwnProperty.call(value, key);

const isMoneyRecord = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

/**
 * Management voucher reads historically returned decimal scalars while
 * mutations returned the shared amount_minor money DTO. Keep that
 * compatibility at one boundary so every card receives a renderable value.
 */
export const normalizeVoucherMoney = (value) => {
  if (value === null || value === undefined || value === "") return "";
  if (typeof value === "boolean" || Array.isArray(value)) return "";

  const raw = isMoneyRecord(value) ? value.amount_minor : value;
  if (raw === null || raw === undefined || raw === "" || typeof raw === "boolean") return "";

  const number = isMoneyRecord(value) ? Number(raw) / 100 : Number(raw);
  return Number.isFinite(number) ? number.toFixed(2) : "";
};

export const normalizeVoucher = (voucher = {}) => {
  if (!voucher || typeof voucher !== "object" || Array.isArray(voucher)) return voucher;

  const normalized = { ...voucher };
  if (hasOwn(voucher, "amount")) normalized.amount = normalizeVoucherMoney(voucher.amount);
  if (hasOwn(voucher, "cost")) normalized.cost = normalizeVoucherMoney(voucher.cost);
  return normalized;
};

export const normalizeVoucherPage = (response) => {
  if (Array.isArray(response)) {
    return {
      data: response.map(normalizeVoucher),
      current_page: 1,
      last_page: 1,
      next_page_url: null,
      total: response.length,
    };
  }
  if (!response || typeof response !== "object") return response;
  if (!Array.isArray(response.data) && !hasOwn(response, "data") && (hasOwn(response, "id") || hasOwn(response, "voucher_id"))) {
    return {
      data: [normalizeVoucher(response)],
      current_page: 1,
      last_page: 1,
      next_page_url: null,
      total: 1,
    };
  }
  return {
    ...response,
    ...(Array.isArray(response.data)
      ? { data: response.data.map(normalizeVoucher) }
      : {}),
  };
};
